var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59252 6L3.73402 2.1425C3.66035 2.0685 3.62402 1.97983 3.62502 1.8765C3.62602 1.77317 3.66335 1.6845 3.73702 1.6105C3.81102 1.53683 3.89985 1.5 4.00352 1.5C4.10685 1.5 4.19535 1.53683 4.26902 1.6105L8.08752 5.4315C8.16819 5.5125 8.22719 5.6025 8.26452 5.7015C8.30152 5.80117 8.32002 5.90067 8.32002 6C8.32002 6.09933 8.30152 6.19867 8.26452 6.298C8.22719 6.39733 8.16819 6.48733 8.08752 6.568L4.26652 10.39C4.19252 10.4637 4.10419 10.5 4.00152 10.499C3.89919 10.498 3.81119 10.4607 3.73752 10.387C3.66385 10.3133 3.62702 10.2247 3.62702 10.121C3.62702 10.0177 3.66369 9.92917 3.73702 9.8555L7.59252 6Z",
    fill: "#007F7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.89e6576edac7a1f56e8eeb93c3d122d2.svg";
export { ForwardRef as ReactComponent };